// src/lib/toast-config.ts
import { ToastOptions } from 'react-toastify';

// Toast configuration options
export const toastConfig: ToastOptions = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

// Custom toast styles
export const toastStyles: any = {
  success: "bg-[#B87775] text-white border-l-4 border-[#B87775]",
  error: "bg-red-500 text-white border-l-4 border-red-700",
  info: "bg-blue-500 text-white border-l-4 border-blue-700",
  warning: "bg-yellow-500 text-white border-l-4 border-yellow-700",
  default: "bg-gray-500 text-white border-l-4 border-gray-700",
};

// Toast container configuration
export const toastContainerConfig = {
  toastClassName: (context: any) =>
    `${toastStyles[context?.type || 'default']} relative flex p-4 min-h-10 rounded-md justify-between overflow-hidden cursor-pointer my-2 shadow-lg`,
  bodyClassName: () => "text-sm font-white font-medium block p-3",
  progressClassName: (context: any) =>
    context?.type === 'success' 
      ? 'bg-white' 
      : 'bg-white opacity-70',
};